// enum State {
//   Waiting, /// 대기 (다음 상태: 모금)
//   Fundraising, /// 모금 진행 (다음 상태: 운영 or 모금 잠김 or 모금 중지 or 모금 실패)
//   FundraisingLocked, /// 모금 잠김 (다음 상태: 운영)
//   FundraisingStopped, /// 모금 중지
//   FundraisingFailed, /// 모금 실패
//   Operating, /// 운영 (다음 상태: 운영 종료 or 운영 중지)
//   OperatingClosed, /// 운영 종료
//   OperatingStopped /// 운영 중지
// }

export const StateFilter = (aData: string | number): string => {
  let re = null;
  switch (aData) {
    case '0':
    case 0:
      re = 'Waiting';
      break;
    case '1':
    case 1:
      re = 'Fundraising';
      break;
    case '2':
    case 2:
      re = 'Fundraising Locked';
      break;
    case '3':
    case 3:
      re = 'Fundraising Stopped';
      break;
    case '4':
    case 4:
      re = 'Fundraising Failed';
      break;
    case '5':
    case 5:
      re = 'Operating';
      break;
    case '6':
    case 6:
      re = 'Operating Closed';
      break;
    case '7':
    case 7:
      re = 'Operating Stopped';
      break;

    default:
      re = String(aData);
      break;
  }
  return re;
};

export const StatusFilter = (aData: string | undefined): string => {
  if (!aData) {
    return '';
  }
  let re = null;
  if (aData.startsWith('stakeToken')) {
    re = 'Staked';
  } else if (aData.startsWith('claimReward')) {
    re = 'Claim Reward';
  } else if (aData.startsWith('unStakeToken')) {
    re = 'Unstaked';
  } else if (aData.startsWith('0x8448705b')) {
    re = 'withdraw';
  } else if (aData.startsWith('claimAllReward')) {
    re = 'Claim All Reward';
  } else {
    re = aData;
  }
  return re;
};
